export default { launchFlow: {
  draftArcaReadonly: 'DS의 기존 디자인 초안은 조회만 가능합니다. 향후 디자인 원본은 ARCA에서 제공하며 연동은 아직 제공되지 않습니다.',
  manualCreationClosed: '수동 스타일 생성이 종료되었습니다. 기존 자료는 조회할 수 있으며, 생성된 작업지시서는 기존 권한으로 관리합니다.',
  createDesign: '디자인 생성', kindDraft: '디자인', kindSheet: '정식 작업지시서', prototype: 'Prototype · 디자인 단계',
  libraryHint: '시즌, 품목 또는 단계별로 스타일, 작업지시서 및 기존 디자인 초안을 조회합니다.',
  libraryEmpty: '디자인 또는 작업지시서가 없습니다', libraryEmptyHint: '내 작업에서 SAP가 배정한 스타일을 수신할 수 있습니다.',
  syncQuantities:'SAP 주문 수량 동기화', quantitySynced:'원본 주문 수량을 확인하고 갱신했습니다.', quantityNotProvided:'SAP에 주문 수량이 없어 기존 수량 및 대기 상태를 유지했습니다.',
  quantityDimensionsChanged:'원본 컬러 또는 사이즈 범위가 변경되었습니다. 스타일 자료를 확인해 주세요. 이번에는 수량을 변경하지 않았습니다.',
  quantityInvalid:'원본 주문 수량이 유효하지 않아 작업지시서를 변경하지 않았습니다.',
  quantitySourceOnly:'이 작업지시서는 SAP로 수량을 갱신할 수 없습니다. 수주 시스템에서 생성한 자료는 해당 원본에서 갱신해야 합니다.',
  plannerPaused: '이번 버전에서는 상품기획 기능을 제공하지 않습니다. SAP에서 스타일과 주문 정보를 관리해 주세요.',
  fromSap: 'SAP 스타일로 생성', precreate: '디자인으로 사전 작성', preSheets: '사전 작성 작업지시서',
  precreateHint: '디자이너 스타일 번호로 디자인, 원부자재 및 메모를 저장하고 정식 스타일 생성 후 SAP에서 조회하여 연결합니다.',
  cacheUsed: '로컬 캐시 사용({age} 동기화). SAP를 호출하지 않았습니다.',
  cacheJustNow: '방금',
  cacheMinutesAgo: '{n}분 전',
  forceRefresh: 'SAP에서 강제 새로고침',
  querySap: 'SAP 조회', querying: '스타일, 컬러 및 사이즈를 조회하고 있습니다. 잠시 기다려 주세요.', stylePlaceholder: '전체 스타일 번호 입력',
  quantityPending: '주문 수량 대기: SAP 또는 수주 시스템에서만 가져옵니다. 디자인 자료는 먼저 작성할 수 있습니다.',
  styleBrand: '스타일과 사전 작성 작업지시서의 브랜드가 다릅니다. 확인해 주세요.',
  queryAndLink: 'SAP 정식 스타일 조회', linkExisting: '기존 작업지시서 연결', createAndLink: '정식 작업지시서 생성 및 연결',
  detailUnavailable: 'SAP 컬러·사이즈 조회에 실패하여 캐시를 갱신하지 않았습니다. 나중에 다시 조회해 주세요.',
  dimensionsMissing: 'SAP 컬러·사이즈가 아직 완성되지 않았습니다. 디자인으로 작업지시서를 먼저 작성할 수 있습니다.',
  queryFirst: 'SAP 스타일을 조회하여 컬러·사이즈를 가져온 후 연결해 주세요.',
  sheetExists: '이미 작업지시서가 있습니다. 기존 작업지시서 연결에서 확인 후 연결해 주세요.',
  mergeReviewRequired: '직접 확인이 필요한 차이가 있어 정식 작업지시서를 생성하지 않았습니다. 사전 작성 자료를 확인해 주세요.',
  openFormal: '정식 작업지시서에 연결되었습니다. 정식 작업지시서에서 편집해 주세요.',
}, styleIntake: {
 assignmentAlert:'담당 사번이 없거나 일치하지 않는 스타일이 {n}개 있습니다. 관리자 또는 브랜드 상품기획 담당자가 배정해 주세요.',configureOwners:'담당자 설정',
"runSummary":"브랜드 수신 기록: 자료 대기 {waiting} · 오류 {errors} · 24시간 초과 {overdue}",
"lastChecked":"최근 확인",
"waitingSourceTask":"SAP 자료 대기",
"waitingSourceHint":"SAP 품명·색상·사이즈 자료가 아직 도착하지 않았습니다. 배정된 작업을 먼저 진행할 수 있으며 입력한 내용은 유지됩니다.",
"waitingOverdue":"자료 대기 24시간 초과",
"fillTitle":"SAP 자료 보완 검토",
"fillHint":"이미 받은 SAP 자료로 빈 항목만 보완하며 직접 입력한 내용은 유지합니다.",
"fillConfirm":"미리보기대로 빈 자료를 보완할까요? 기존 입력·승인·공장 발행본은 유지됩니다.",
"fillApply":"보완 확인",
"fillSaved":"받은 자료를 보완했습니다",
"fillEmpty":"현재 보완할 자료가 없습니다. SAP 자료 수신을 기다려 주세요.",
"fillMatrix":"색상 {colors}, 사이즈 {sizes} 보완. 주문 수량 {n}개 셀을 받았으며 나머지는 미수신으로 유지합니다.",
"fillPreserved":"직접 수정한 항목 또는 수량 범위는 유지합니다. 작업지시서에서 확인해 주세요.",
"scopePending":"먼저 이번 수신의 브랜드와 연도를 설정해 주세요",
"environmentConflict":"기존 작업지시서의 SAP 환경과 다릅니다. 관리자에게 확인해 주세요.",
"sourceProtected":"확인·공장 발행 또는 직접 수정한 자료를 다시 확인해 주세요",
"fillReasons":{"notLegacy":"SAP 수신으로 생성한 자료가 아닙니다","confirmedOrSent":"완료·승인·공장 발행 기록이 있어 자동 보완하지 않습니다","historyLimit":"수정 이력이 많습니다. 관리자 확인이 필요합니다.","cancelled":"SAP 원본이 취소되었습니다","quantityInvalid":"SAP 수량 자료가 상충합니다. 먼저 확인해 주세요.","matrixTooLarge":"색상·사이즈 범위가 처리 한도를 초과합니다"},
"reviewChanges": "원본 변경 확인",
"compareHint": "이전 및 최신 수신 자료의 차이입니다. 현재 작업지시서 내용은 유지됩니다.",
"field": "항목",
"previousSource": "이전 수신 자료",
"latestSource": "최신 수신 자료",
"metadataChanged": "담당자 표기 또는 수신 상태가 변경되었습니다. 대기 사유와 함께 확인해 주세요.",
"quantityCell": "수량 · {cell}",
"moreChanges": "전체 {n}개 차이 중 처음 100개를 표시합니다.",
"fields": {"salePriceCurrency":"통화","styleNm": "품명", "productYear": "연도", "season": "시즌", "receivingDueDate": "입고 요청일", "salePrice": "판매가", "designerNo": "디자이너 사번", "plannerNo": "상품기획 사번", "fabricPurNo": "원단 구매 사번", "trimPurNo": "부자재 구매 사번", "productionNo": "생산 담당자 사번", "patternNo": "패턴 담당자 사번", "cadNo": "CAD 사번", "colors": "컬러 범위", "sizes": "사이즈 범위", "cancelled": "원본 취소 상태"},
  "receiverError": "자동 수신을 확인해야 합니다. 처리 대기 항목을 확인하거나 관리자에게 문의해 주세요",
  "myStyles":"내 스타일","teamStyles":"팀 스타일","managementTitle":"스타일 관리","manage":"스타일 번호 관리","myPending":"처리할 작업","myApprovals":"승인할 작업","all":"전체","yearSeason":"연도 / 시즌","open":"보기","continue":"처리","noStyles":"스타일이 없습니다","noTasks":"처리할 작업이 없습니다","styleCount":"총 {n}개 스타일","actions":{"DESIGNER": "디자인 작성", "APPROVER": "승인", "PATTERN": "치수 작성", "FABRIC": "자재 확인", "PRODUCTION": "Tech Pack 작성", "PLANNER": "수량 확인", "consumption": "소요량 작성", "VIEWER": "보기"},"managementTabs":{"assignments": "기존 스타일 담당", "sources": "SAP 수신 스타일", "intake": "수신 예외"},
  "workbench": "스타일 워크스페이스",
  "refreshStatus": "워크스페이스 새로고침",
  "autoActive": "SAP 스타일 자동 수신 중",
  "autoInactive": "SAP 스타일 자동 수신 미활성",
  "schemaPending": "자동 수신 준비가 완료되지 않았습니다. 관리자에게 문의해 주세요",
  "total": "처리 대기 {n}건",
  "noExceptions": "수신 처리 대기 항목이 없습니다",
  "state": "처리 상태",
  "pendingReason": "대기 사유",
  "keepCurrent": "현재 작업지시서 유지",
  "keepConfirm": "원본 변경을 확인하고 현재 작업지시서를 유지하시겠습니까? 기존 내용은 덮어쓰지 않습니다.",
  "intakeIssues": "수신 처리 대기",
  "notFound": "수신 기록이 없습니다",
  "changed": "수신 자료가 변경되었습니다. 새로고침 후 다시 확인해 주세요",
  "roleIssue": "{role}: {reason}",
  "tabs": {
    "mine": "내 할 일",
    "all": "전체 스타일",
    "exceptions": "처리 대기"
  },
  "states": {
    "WAITING_SOURCE": "자료 대기",
    "REVIEW": "확인 대기",
    "ERROR": "처리 실패",
    "CREATED": "생성 완료",
    "EXISTING": "기존 작업지시서"
  },
  "reasons": {
    "environmentConflict": "다른 수신 환경의 작업지시서가 있습니다. 관리자가 원본을 확인해야 합니다",
    "nameMissing": "품명 수신 대기",
    "dimensionsMissing": "컬러 또는 사이즈 수신 대기",
    "quantityMissing": "주문 수량 보완 대기",
    "quantityInvalid": "주문 수량이 충돌하거나 유효하지 않습니다",
    "cancelled": "원본 취소됨. 기존 작업지시서를 확인해 주세요",
    "matrixTooLarge": "컬러·사이즈 범위를 확인해 주세요",
    "ambiguousIdentity": "스타일 또는 생산 차수 식별 충돌",
    "sourceChanged": "원본 자료 변경. 적용 여부를 확인해 주세요",
    "sheetRemoved": "기존 작업지시서 삭제됨. 담당자 결정 대기",
    "processingError": "처리 실패. 관리자 수신 로그 확인 필요",
    "unmatched": "유효한 직무 및 브랜드 권한과 사번이 일치하지 않습니다",
    "unassigned": "담당자 미지정",
    "personChanged": "로컬 담당자의 상태가 변경되었습니다"
  }
} };
